import { render, staticRenderFns } from "./TypeEvidenceStatusForm.vue?vue&type=template&id=61cbc4ff&"
import script from "./TypeEvidenceStatusForm.vue?vue&type=script&lang=js&"
export * from "./TypeEvidenceStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports